import { getAccessTokenJwtHeader } from '@/assets/src/amplify/helpers';
import { getJson } from '@/assets/src/json_loader';
import { API_URL } from '@/assets/src/configs';
import { getQueryFromSearchParameters } from '@/assets/src/search_parameter';
import { SearchParameter } from '@/assets/src/search_parameter';

const failedDemosEndpoint = `${API_URL}/private/failed_demos`;
const demosEndpoint = `${API_URL}/private/demos`;

export interface FailedDemo {
  id: number;
  url: string;
  sha256: string;
  user_id: number;
  user_cognito_id: string;
  failed_at: string;
}

export interface Demo {
  uploader_cognito_id: string;
  demo_hash: string;
  uploaded_at: string;
  url: string;
  file_name: string;
  map_name: string;
  team1_name: string;
  team1_score: number;
  team2_name: string;
  team2_score: number;
}

export class DemoClient {
  public async listFailedParsings(searchParameters: SearchParameter[]): Promise<FailedDemo[]> {
    const headers = await getAccessTokenJwtHeader();
    const query = getQueryFromSearchParameters(searchParameters);
    const endpoint = failedDemosEndpoint + query;
    const response: any = await getJson(endpoint, headers);

    return response.demos;
  }

  public async listUsersDemos(cognitoId: string, searchParameters: SearchParameter[]): Promise<Demo[]> {
    const headers = await getAccessTokenJwtHeader();
    const query = getQueryFromSearchParameters(searchParameters);
    const endpoint = `${demosEndpoint}/${cognitoId}${query}`;
    const response: any = await getJson(endpoint, headers);

    return response.demos;
  }
}
